import v46Schema from "../client/schemaVersions/v46.js";
import v47Schema from "../client/schemaVersions/v47.js";
import { createMigration } from "@verdant-web/store";
export default createMigration(v46Schema, v47Schema, async ({ migrate }) => {
    // add or modify migration logic here. you must provide migrations for
    // any collections that have changed field types or added new non-nullable
    // fields without defaults
    // await migrate('collectionName', async (old) => ({ /* new */ }));
});
//# sourceMappingURL=v47.js.map